// extracted by mini-css-extract-plugin
export default {"error_icon_tooltip_trigger":"FilesTable_error_icon_tooltip_trigger__J6fFM","table":"FilesTable_table__KW5Hh"};